import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/70 py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div className="animate-fade-in-up">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {t('home:categorySection.title', '漫画分类')}
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              {t('home:categorySection.subtitle', '多样化分类，快速找到你喜欢的漫画类型')}
            </p>
          </div>
          <Link
            to="/category/all"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {categories.map((category, index) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer hover:scale-[1.02]"
              style={{ animationDelay: `${index * 0.07}s` }}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors mb-4">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{category.name}</h3>
              <p className="text-xs text-foreground-500">{category.count.toLocaleString()} 部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}